module.exports = {
  SOURCE_ID_MP: '2084',
  SOURCE_ID_ML: '2085',
  FLOW_AA_ML: 'AA_ML',
  FLOW_AA_MP: 'AA_MP_HOME',
  SCOPE_PRODUCTION: 'production',
};
